import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { store } from 'redux/store'
import { Provider } from 'react-redux'
import App from './App';

import { BrowserRouter as Router, Route} from "react-router-dom";
import { unregister } from './registerServiceWorker';

//const store = createStore(rootReducer)

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <Route path="/" component={App} />      
        </Router>        
    </Provider>,
    document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js